<div class="container-fluid p-0">
  <div class="w-100 position-relative vh-100">
    <div class="row g-0 h-100">
      <!-- ================= LEFT BRAND PANEL ================= -->

      <div class="col-lg-5 d-none d-lg-flex auth-gradient-panel">
        <div class="left-panel-wrapper w-100 px-5">
          <!-- Center Content -->
          <div class="left-panel-content">
            <!-- Logo -->
            <div class="d-flex align-items-center gap-2 mb-5 d-none">
              <div class="auth-logo-badge">
                <i class="ti ti-users-group fs-24"></i>
              </div>

              <img
                src="../../../../assets/img/logo/logo.webp"
                class="img-fluid auth-brand-logo"
                alt="Logo"
              />
            </div>

            <h1 class="text-white fw-bold display-6 mb-3">Simplify your workforce management.</h1>

            <p class="auth-subtext mb-5">
              Join hundreds of modern workspaces optimizing tracking, onboarding compliance, and
              real-time operations natively from one secure hub.
            </p>

            <ul class="list-unstyled">
              <li class="d-flex align-items-center gap-2 mb-3">
                <span class="auth-check-icon">
                  <i class="ti ti-check"></i>
                </span>
                <span class="text-white fw-medium"> Automated Leave &amp; Shift Rostering </span>
              </li>

              <li class="d-flex align-items-center gap-2">
                <span class="auth-check-icon">
                  <i class="ti ti-check"></i>
                </span>
                <span class="text-white fw-medium"> Secure Employee Profile Vaults </span>
              </li>
            </ul>
          </div>

          <!-- Footer -->
          <div class="left-panel-footer">
            <p class="auth-subtext mb-0" [innerHTML]="copyrightText"></p>
          </div>
        </div>
      </div>

      <!-- ================= RIGHT FORM PANEL ================= -->

      <div class="col-lg-7 col-md-12 col-sm-12 d-flex">
        <div class="row w-100 justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-9 col-xl-8 auth-form-container">
            <!-- ================= THANK YOU MESSAGE ================= -->

            <div *ngIf="showThankYouMessage$ | async; else registrationForm" class="text-center">
              <div class="d-flex flex-column justify-content-center min-vh-100 p-4">
                <!-- Mobile Logo -->

                <div class="d-lg-none mb-4">
                  <img
                    src="../../../../assets/img/logo/logo.webp"
                    class="img-fluid auth-brand-logo"
                    alt="Logo"
                  />
                </div>

                <div class="auth-success-icon mx-auto mb-4">
                  <i class="ti ti-mail-check"></i>
                </div>

                <h2 class="fw-bold mb-2">Thank You!</h2>

                <p class="text-muted">
                  Your registration was successful! We've sent you an email containing a secure link
                  to set your password.
                </p>

                <div class="mb-4">
                  <h5 class="fw-normal text-dark">
                    <a
                      routerLink="/auth/login"
                      class="hover-a auth-link"
                      (click)="handleSignInClick()"
                    >
                      Sign In
                    </a>
                  </h5>
                </div>

                <div>
                  <img
                    src="../../../../assets/img/register_email.png"
                    class="img-fluid"
                    alt="Email"
                  />
                </div>
              </div>
            </div>

            <!-- ================= REGISTRATION FORM ================= -->

            <ng-template #registrationForm>
              <form [formGroup]="form" (ngSubmit)="register()">
                <div class="d-flex flex-column justify-content-center h-100 p-4">
                  <!-- FORM LOGO -->

                  <div class="text-center mb-4">
                    <img
                      src="../../../../assets/img/logo/logo.webp"
                      class="img-fluid auth-brand-logo"
                      alt="Logo"
                    />
                  </div>

                  <!-- TITLE -->

                  <div class="text-center mb-4">
                    <h2 class="fw-bold mb-2">Create your account</h2>

                    <p class="text-muted mb-0">
                      Please enter your operational details to register.
                    </p>
                  </div>

                  <!-- FORM FIELDS CONTINUE IN PART 2 -->
                  <!-- FIRST NAME + LAST NAME -->

                  <div class="row g-3">
                    <!-- First Name -->

                    <div class="col-md-6">
                      <div class="mb-0">
                        <label class="form-label fw-semibold"> First Name </label>

                        <div class="input-group auth-input-group">
                          <span class="input-group-text">
                            <i class="ti ti-user"></i>
                          </span>

                          <input
                            appTrimInput
                            type="text"
                            formControlName="firstName"
                            placeholder="John"
                            class="form-control"
                          />
                        </div>

                        <div
                          class="mt-1"
                          *ngIf="form.get('firstName')?.invalid && form.get('firstName')?.touched"
                        >
                          <span class="text-danger small">
                            {{ getErrorMessage('firstName') }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Last Name -->

                    <div class="col-md-6">
                      <div class="mb-0">
                        <label class="form-label fw-semibold"> Last Name </label>

                        <div class="input-group auth-input-group">
                          <span class="input-group-text">
                            <i class="ti ti-user"></i>
                          </span>

                          <input
                            appTrimInput
                            type="text"
                            formControlName="lastName"
                            placeholder="Doe"
                            class="form-control"
                          />
                        </div>

                        <div
                          class="mt-1"
                          *ngIf="form.get('lastName')?.invalid && form.get('lastName')?.touched"
                        >
                          <span class="text-danger small">
                            {{ getErrorMessage('lastName') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- BUSINESS NAME -->

                  <div class="mt-3">
                    <label class="form-label fw-semibold"> Business Name </label>

                    <div class="input-group auth-input-group">
                      <span class="input-group-text">
                        <i class="ti ti-building"></i>
                      </span>

                      <input
                        appTrimInput
                        type="text"
                        formControlName="businessName"
                        placeholder="Acme Corporation"
                        class="form-control"
                      />
                    </div>

                    <div
                      class="mt-1"
                      *ngIf="form.get('businessName')?.invalid && form.get('businessName')?.touched"
                    >
                      <span class="text-danger small">
                        {{ getErrorMessage('businessName') }}
                      </span>
                    </div>
                  </div>

                  <!-- MOBILE -->

                  <div class="mt-3">
                    <label class="form-label fw-semibold"> Mobile Number </label>

                    <div class="input-group auth-input-group">
                      <span class="input-group-text">
                        <i class="ti ti-phone"></i>
                      </span>

                      <input
                        appTrimInput
                        type="text"
                        formControlName="mobile"
                        placeholder="+91 98765 43210"
                        class="form-control"
                      />
                    </div>

                    <div
                      class="mt-1"
                      *ngIf="form.get('mobile')?.invalid && form.get('mobile')?.touched"
                    >
                      <span class="text-danger small">
                        {{ getErrorMessage('mobile') }}
                      </span>
                    </div>
                  </div>

                  <!-- EMAIL -->

                  <div class="mt-3">
                    <label class="form-label fw-semibold"> Email Address </label>

                    <div class="input-group auth-input-group">
                      <span class="input-group-text">
                        <i class="ti ti-mail"></i>
                      </span>

                      <input
                        appTrimInput
                        type="email"
                        formControlName="email"
                        appStrictEmail
                        placeholder="john.doe@workspace.com"
                        class="form-control"
                      />
                    </div>

                    <div
                      class="mt-1"
                      *ngIf="form.get('email')?.invalid && form.get('email')?.touched"
                    >
                      <span class="text-danger small">
                        {{ getErrorMessage('email') }}
                      </span>
                    </div>
                  </div>

                  <!-- COUNTRY + STATE -->

                  <div class="row g-3 mt-1">
                    <!-- Country -->

                    <div class="col-md-6">
                      <label class="form-label fw-semibold">
                        Country
                        <span class="text-danger">*</span>
                      </label>

                      <select
                        class="form-select auth-select"
                        formControlName="country"
                        [(ngModel)]="selectedCountryId"
                        (change)="onCountrySelect(selectedCountryId)"
                      >
                        <option value="">Select Country</option>

                        <option *ngFor="let country of countries$ | async" [value]="country.id">
                          {{ country.name }}
                        </option>
                      </select>
                      <div
                        class="mt-1"
                        *ngIf="form.get('country')?.invalid && form.get('country')?.touched"
                      >
                        <span class="text-danger small">
                          {{ getErrorMessage('country') }}
                        </span>
                      </div>
                    </div>

                    <!-- State -->

                    <div class="col-md-6">
                      <label class="form-label fw-semibold">
                        State / Province

                        <span class="text-danger">*</span>
                      </label>

                      <select
                        class="form-select auth-select"
                        formControlName="state"
                        [(ngModel)]="selectedStateId"
                        [disabled]="!selectedCountryId"
                      >
                        <option value="">Select State</option>

                        <option *ngFor="let state of states$ | async" [value]="state.id">
                          {{ state.name }}
                        </option>
                      </select>
                      <div
                        class="mt-1"
                        *ngIf="form.get('state')?.invalid && form.get('state')?.touched"
                      >
                        <span class="text-danger small">
                          {{ getErrorMessage('state') }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- GST + BUTTON CONTINUE IN PART 3 -->
                  <!-- GST QUESTION -->

                  <div *ngIf="showGstQuestion" class="mt-4">
                    <label class="form-label fw-semibold d-flex align-items-center flex-wrap gap-2">
                      <span> Do you have GST? </span>

                      <div class="form-check form-switch mb-0">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          [(ngModel)]="hasGst"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="onGstToggle()"
                        />

                        <span class="ms-2">
                          {{ hasGst ? 'Yes' : 'No' }}
                        </span>
                      </div>
                    </label>
                  </div>

                  <!-- GST NUMBER -->

                  <div *ngIf="showGstInput" class="mt-3">
                    <label class="form-label fw-semibold">
                      GST Number

                      <span class="text-danger">*</span>
                    </label>

                    <div class="input-group auth-input-group">
                      <span class="input-group-text">
                        <i class="ti ti-file-certificate"></i>
                      </span>

                      <input
                        type="text"
                        class="form-control"
                        formControlName="gstNumber"
                        placeholder="Enter GST Number"
                      />
                    </div>

                    <div
                      class="mt-1"
                      *ngIf="form.get('gstNumber')?.invalid && form.get('gstNumber')?.touched"
                    >
                      <span class="text-danger small"> Enter a valid GST Number </span>
                    </div>
                  </div>

                  <!-- SUBMIT BUTTON -->

                  <div class="mt-4">
                    <button
                      type="submit"
                      class="btn auth-btn-primary w-100"
                      [disabled]="form.invalid"
                    >
                      <ng-container *ngIf="isLoading$ | async; else loading">
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>

                        Signing Up...
                      </ng-container>

                      <ng-template #loading> Sign Up </ng-template>
                    </button>
                  </div>

                  <!-- LOGIN LINK -->

                  <div class="text-center mt-4">
                    <h6 class="fw-normal text-dark mb-0">
                      Already have an account?

                      <a routerLink="/auth/login" class="auth-link"> Sign In </a>
                    </h6>
                  </div>

                  <!-- MOBILE COPYRIGHT -->

                  <div class="mt-4 pb-3 text-center d-lg-none">
                    <p class="mb-0 text-gray-9 small" [innerHTML]="copyrightText"></p>
                  </div>
                </div>
              </form>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
